import script from "./goRinSyo0041.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0041.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0041.vue?vue&type=style&index=0&id=5acb6642&lang=scss"

const __exports__ = script;

export default __exports__